import CalendarModalMobile from "./calendarModalMobile";
import {Modal} from "antd";

const CalendarParent = ({visible, onCancel, onData, date}) => {

    return (
        <Modal visible={visible}
               width={343}
               onCancel={() => {
                   onCancel()
               }}
               className="modalStyleCalendar"
               footer={null}
               closable={false}>
            <CalendarModalMobile onCancel={onCancel}
                                 onData={onData}
                                 date={date}/>
        </Modal>
    )
}
export default CalendarParent
